import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";

import { colors } from "@material-ui/core";
export function TotalsTas({ infData }) {
  const cls = useRptAF();

  const styleE = {
    border: "solid 1px ",
    borderColor: "black",
    textAlign: "center",
    padding: 2,
    fontSize: "0.6rem",
    color: "black",
    fontWeight: "bold",
  };
  const styleTo = {
    border: "solid 1px ",
    borderColor: "black",
    textAlign: "center",
    fontSize: "0.8rem",
    fontWeight: "bold",
  };
  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container className={cls.rootBdyup}>
        <Grid container lg={12} md={12} className={cls.rootBdydown}>
          <Grid container xs={12} /*className={cls.rootchip}*/>
            <Grid item xs={3} style={styleE}>
              {"عدد الالصناف"}
            </Grid>
            <Grid item xs={2} style={styleE}>
              {" الكميات قبل"}
            </Grid>
            <Grid item xs={2} style={styleE}>
              {"الكميات بعد"}
            </Grid>
            <Grid item xs={2} style={styleE}>
              {"اجمالي الفارق"}
            </Grid>

            <Grid item xs={3} style={styleE}>
              {"اجمالي السعر "}
            </Grid>
          </Grid>
          <Grid container xs={12} /*className={cls.rootchip}*/>
            <Grid item xs={3} style={styleTo}>
              {/* {totals?.count.toFixed(2)} */}
              {infData.tot.count}

            </Grid>
            <Grid item xs={2} style={styleTo}>
              {/* {totals?.totQun?.toFixed(2)} */}
              {infData.tot.totQun}

            </Grid>
            <Grid item xs={2} style={styleTo}>
              {/* {totals?.totQun2?.toFixed(2)} */}
              {infData.tot.totQun2}

            </Grid>
            <Grid item xs={2} style={styleTo}>
              {/* {totals?.totdiff?.toFixed(2)} */}
              {infData.tot.totdiff}

            </Grid>
            <Grid item xs={3} style={styleTo}>
              {/* {totals?.totPrice?.toFixed(2)} */}
              {infData.tot.totPrice}

            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

function BodyTwsaya({ data, isLast, infData }) {
  const cls = useRptAF();

  const cellS = {
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "14px",
    width: "32%",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };
  var columns = [
    { title: "الباركود", field: "barcode" },
    { title: "الصنف", field: "symbol", cellStyle: cellS },
    { title: "الوحدة", field: "unitName" },
    { title: "الكمية قبل", field: "val1" },
    { title: "الكمية بعد", field: "val2" },
    { title: "الفارق", field: "diff" },
    { title: " السعر", field: "Price" },
    { title: "الاجمالي", field: "SumPrice" },
  ];
  const data2 = data.map((row, i) => {
    return {
      ...row,
      idd: i + 1,
      total: parseFloat(row.total).toFixed(2),
    };
  });
  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container className={cls.rootBdyup}  >
        <Grid
          item
          xs={12}
        >
          <MaterialTable
            style={{ boxShadow: "none", width: "100%", tableLayout: "fixed" }}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",


              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
              },
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 style={{ color: "GrayText" }}>
                    لا توجد ارصدة بعد في هذا الحساب
                  </h5>
                ),
              },
            }}
            columns={columns}
            data={data2}
          />
          {isLast && <TotalsTas infData={infData} />}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default BodyTwsaya;
